import React, {useState, useCallback, Fragment, useContext} from "react";
import { Link } from "gatsby";

import { Menu, MenuItem, IconButton } from "@mui/material";

import { getEntityUrl, getTranslatedEntityLink } from "../../util"
import {Language, Translate} from "@mui/icons-material";
import {SettingsContext} from "../../context/SettingsContext";

const LANGUAGE_ICON_GLOBE = false;

const LanguageSelector = ({ locales, pageContext, entity, ...props }) => {
    const { settings } = useContext(SettingsContext)

    const { defaultLocale, locale: selectedLocale } = pageContext || {};


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    }, [setAnchorEl]);

    return settings?.Topbar?.languageSelection === 'topbar' && (locales?.length > 1 || settings.Topbar?.pseudoLanguages > 0) && (
        <Fragment>
            <IconButton
                edge="end"
                color="inherit"
                aria-label="language"
                onClick={handleMenu}>
                {LANGUAGE_ICON_GLOBE ? <Language /> : <Translate /> }
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} keepMounted style={{ zIndex: 65535 }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left", }} >

                {locales.map(l => {
                    const link = getTranslatedEntityLink({ locale: l, defaultLocale, entity });
                    return <MenuItem key={l.code} onClick={handleClose} component={Link} to={link}>{l.name}</MenuItem>
                })}

                {settings.Topbar.pseudoLanguages?.map(item => {
                    const link = getEntityUrl({ defaultLocale, entity: item });
                    return <MenuItem key={item.identifier} onClick={handleClose} component={Link} to={link}>{item.title}</MenuItem>
                })}
            </Menu>
        </Fragment>
    )
};

export default LanguageSelector;
